import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LangContext";
import { formatApiError } from "../lib/api";
import useSEO from "../lib/useSEO";

export default function AdminLogin() {
  const { t } = useLang();
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useSEO({ title: "Admin Login | Tæste", noindex: true });

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-[hsl(var(--background))] border border-[hsl(var(--border))] px-4 py-3 text-base outline-none focus:border-[hsl(var(--primary))] focus:ring-2 focus:ring-[hsl(var(--primary))]/30";

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6">
      <Toaster richColors position="top-center" />
      <div className="w-full max-w-md border border-border bg-[hsl(var(--card))] p-10">
        <div className="brand-mark text-4xl text-center mb-2">T<span className="italic">æ</span>ste</div>
        <p className="eyebrow text-center mb-1">{t.admin.login_title}</p>
        <p className="text-center text-sm text-[hsl(var(--muted-foreground))] mb-8">{t.admin.login_sub}</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="eyebrow block mb-2">{t.admin.email}</label>
            <input data-testid="admin-email" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="eyebrow block mb-2">{t.admin.password}</label>
            <input data-testid="admin-password" type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button data-testid="admin-login-button" disabled={loading} type="submit" className="w-full px-6 py-3.5 text-xs tracking-[0.2em] uppercase font-semibold bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:bg-[hsl(var(--accent))] disabled:opacity-60 rounded-sm">
            {loading ? "…" : t.admin.submit}
          </button>
        </form>
      </div>
    </div>
  );
}
